document.addEventListener('DOMContentLoaded', function() {
    let form = document.getElementById('loginForm');

    if(form === null){
        return;
    }

    form.addEventListener('submit', function(event) {
        event.preventDefault();

        let apiPath = form.getAttribute('data-api-path');
        let messageElement = document.getElementById('delete-acount-message');
        let message = '';

        let userData = {
            username: form.querySelector('input[name="email"]').value,
            password: form.querySelector('input[name="wachtwoord"]').value
        };

        let validate = form.querySelector('input[name="validate"]').checked;

        if (!validate){
            message = "U moet uw keuze bevestigen."
            messageElement.classList.add('error');
            messageElement.textContent = message;
            return;
        }

        let loginApiPath = apiPath + '/login';
        let deleteApiPath = apiPath + '/account/delete';

        messageElement.textContent = '';
        messageElement.classList.remove('success', 'error');

        //we check if the user can log in, if we can login the user we can delete the account because it exists, we do another post te delete the account
        fetch(loginApiPath, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(userData)
        })
            .then(response => {
                if (!response.ok) {
                    if (response.status === 401) {
                        message = 'Deze combinatie van gebruikersnaam en wachtwoord is niet bij ons bekend.';
                        messageElement.classList.add('error');
                        messageElement.textContent = message;
                    } else {
                        message = 'Er is iets fout gegaan, probeer het later opnieuw.';
                        messageElement.classList.add('error');
                        messageElement.textContent = message;
                    }
                    return response.json().then(data => {
                        message = 'Er is iets fout gegaan, probeer het later opnieuw.';
                        messageElement.classList.add('error');
                        messageElement.textContent = message;
                        throw new Error(message);
                    });
                }
                return response.json();
            })
            .then(data => {
                if (data.token) {
                    const deleteHeaders = {
                        'Authorization': `Bearer ${data.token}`,
                        'Content-Type': 'application/json'
                    };

                    return fetch(deleteApiPath, {
                        method: 'DELETE',
                        headers: deleteHeaders
                    });
                } else {
                    message = 'Geen token ontvangen, kan account niet verwijderen.';
                    messageElement.classList.add('error');
                    messageElement.textContent = message;
                }
            })
            .then(deleteResponse => {
                if (deleteResponse) {
                    if (deleteResponse.ok) {
                        message = 'Gegevens succesvol verwijderd.';
                        messageElement.textContent = message;
                        messageElement.classList.add('success');
                    } else {
                        message = 'Er is iets fout gegaan, probeer het later opnieuw.';
                        messageElement.textContent = message;
                        messageElement.classList.add('error');
                    }
                }
            })
            .catch((error) => {
                message = 'Er is iets fout gegaan, probeer het later opnieuw.';
                messageElement.textContent = message;
                messageElement.classList.add('error');
            });
    });
});
